import { FC } from 'react';

import { Button, Grid } from '@mui/material';

import { useAnalytics } from '../../../hooks/dataTracking/useAnalytics';
import { useAuthStore } from '../../../stores/auth';
import { NoResultsCard } from '../../molecules/NoResultsCard';
import { SubmissionCard } from './SubmissionCard';

export interface SubmissionListProps {
  setNewProposalModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SubmissionList: FC<SubmissionListProps> = ({ setNewProposalModalOpen }) => {
  const user = useAuthStore((store) => store.user);
  const { sendButtonClickTrackingEvent } = useAnalytics();

  const { submissions } = user || {};

  // Loading is unnecessary here as submissions come as part of getting user
  return (
    <Grid container spacing={2}>
      {submissions?.length ? (
        submissions.map((submission) => (
          <Grid xs={12} item key={submission.title}>
            <SubmissionCard {...submission} />
          </Grid>
        ))
      ) : (
        <NoResultsCard
          title="No proposals found"
          subtitle={user ? 'Please submit your first Proposal!' : 'Please login and verify your account!'}
        >
          <Button
            disabled={!user}
            type="button"
            variant="outlined"
            onClick={() => {
              setNewProposalModalOpen(true);
              sendButtonClickTrackingEvent('Open new proposal form for new user');
            }}
            sx={{ mt: 2 }}
          >
            Submit your first Proposal
          </Button>
        </NoResultsCard>
      )}
    </Grid>
  );
};
